import Header from "components/Common/Header/Header";
import HeightBody from "components/PatientManagement/Vital/Height/HeightBody";
import React, { useEffect } from "react";

const Height = () => {
  useEffect(() => {
    document.title = "Vitals | Height";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <HeightBody />
    </main>
  );
};

export default Height;
